// extracted by mini-css-extract-plugin
export default {"burger":"navBar_burger__Dyl4w"};